const helpers = {
    /**
     * Get the value of a cookie
     * Source: https://gist.github.com/wpsmith/6cf23551dd140fb72ae7
     * @param  {String} name  The name of the cookie
     * @return {String}       The cookie value
     */
    getCookie(name) {
        let value = `; ${document.cookie}`;
        let parts = value.split(`; ${name}=`);
        if (parts.length === 2)  {
            return parts.pop().split(';').shift();
        }
        return false;
    },

    setCookie(name, value, ttl = 86400) {
        document.cookie = `${name}=${value}; Max-Age=${ttl}; path=/; SameSite=Strict; Secure`;
    },

    cookieExists(name) {
        return this.getCookie(name)?.length > 0;
    },

    setSecureCookie(advertising_cookie,cookieName) {
        //e.preventDefault();
        const date = new Date();
        const ttl = advertising_cookie.dataset.lightboxPromotionTtl
            ? parseInt(advertising_cookie.dataset.lightboxPromotionTtl, 10)
            : 1;

        // Set the cookie
        date.setDate(date.getDate() + ttl);
        document.cookie =
            `${cookieName}=1; expires=${date.toUTCString()};` +
            `path=/;secure`;
    },

    /* Merge phone prefix and phone number.*/
    mergePhonePrefixAndPhoneNumber(phonePrefix, phoneNumber) {
        let finalPhoneNumber = phonePrefix.replace('+', '00');
        phoneNumber = phoneNumber.replace(/%20/g,'');
        phoneNumber = phoneNumber.replace(/\D/g,'');
        finalPhoneNumber += phoneNumber;
        return finalPhoneNumber;

    },

    scrolledOverH1Headline(firstHeadline, footerHeight, documentHeight) {
        let currentScrollPosition = window.scrollY;
        let firstHeadlineYPosition = firstHeadline.getBoundingClientRect().y;
        if (currentScrollPosition > firstHeadlineYPosition && (currentScrollPosition + window.innerHeight) < (documentHeight - footerHeight)) {
            return true;
        } else {
            return false;
        }
    },

    urlQueryParameterExists(currentModalName, urlParameterName, urlParameterValue) {
        const url = new URL(window.location.href);
        if(url.searchParams.has(urlParameterName) && String(url.searchParams.get(urlParameterName)) === 'true' || parseInt(url.searchParams.get(urlParameterName)) === urlParameterValue) {
            return true;
        } else {
            return false;
        }
    },

    /**
     * Delete all relevant bexio Cookies to reset a login
     */
    deleteBxSignupCookies: function() {
        const cookieCollection= [
            'WEBSITE_BX_REFRESH_TOKEN',
            'WEBSITE_BX_USER_AUTHENTICATION',
            'WEBSITE_BX_USER_AUTH',
            'WEBSITE_BX_USER_AUTHENTICATION_KEY',
        ];
        cookieCollection.forEach(function(cookieName) {
            if (window.helpers.cookieExists(cookieName)) {
                window.helpers.setCookie(cookieName, '', 1);
            }
        });
    },

    deleteWebinarIdCookie() {
        if (window.helpers.cookieExists('WEBSITE_BX_EVENT_ID')) {
            window.helpers.setCookie('WEBSITE_BX_EVENT_ID', '', 1);
            //console.info("WebinarID not found and deleted");
        }
    }
}

export { helpers as default };
